import { render } from "./Settings.vue?vue&type=template&id=1bdf920c&scoped=true&lang=pug"
import script from "./Settings.vue?vue&type=script&lang=coffee"
export * from "./Settings.vue?vue&type=script&lang=coffee"

import "./Settings.vue?vue&type=style&index=0&id=1bdf920c&scoped=true&lang=stylus"

import exportComponent from "C:\\OSPanel\\home\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdf920c"]])

export default __exports__